import React from "react";
import QRCodePage from "./QRCodePage";

function App() {
  return <QRCodePage />;
}

export default App;
